import { fetchJsonResponse } from '@/ai/api'
import { buildDataFieldExampleDataPrompt } from '@/ai/prompts'

export const generateDataFieldExampleData = async ({
  aiVersion,
  entity,
  dataField,
  abortController
}) => {
  if (!aiVersion) {
    return null
  }

  const messages = buildDataFieldExampleDataPrompt({ entity, dataField })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
